import React, { useEffect, useMemo, useState } from "react";
import { Box, Button, Dialog, Grid, Typography } from "@mui/material";
import { toast } from "react-toastify";

import { TCInput } from "components/TopCourtComponents/Input/TopCourtInput";
import ButtonComponent from "views/components/buttonComponent";
import { currencyFormat } from "helper/NumberFormat";
import { updateMerchantDeposit } from "services/merchantServices";
import { getFirstLetters } from "helper/String";

// TODO: replace with your real services
// import { approveDepositRequest, rejectDepositRequest } from "services/depositServices";

async function approveDepositRequest(_id, adminDiscount) {
    // TODO call API
    await updateMerchantDeposit({
        _id,
        approve: true,
        adminDiscount
    })
    return { data: true };
}

async function rejectDepositRequest(_id, reason) {
    // TODO call API
    await updateMerchantDeposit({
        _id,
        approve: false,
        reason
    })
    return { data: true };
}

export default function MerchantDepositDialog({
    openDialog,
    onClose,
    onDone, // call this to refresh table after success
}) {
    const [loading, setLoading] = useState(false);
    const [reason, setReason] = useState("");
    const [adminDiscount, setAdminDiscount] = useState(0);

    const isReject = openDialog?.type === "reject";
    const row = openDialog?.data;

    useEffect(() => {
        if (openDialog?.open) {
            setReason("");
        }
    }, [openDialog?.open]);

    const title = useMemo(() => {
        if (openDialog?.type === "accept") return "Approve Deposit Request";
        if (openDialog?.type === "reject") return "Reject Deposit Request";
        return "Deposit Request";
    }, [openDialog?.type]);

    const isValid = useMemo(() => {
        if (!row?._id) return false;
        // if (isReject) return reason.trim().length >= 3;
        return true;
    }, [row?._id, isReject, reason]);

    const onSubmit = async () => {
        if (!row?._id) return;

        setLoading(true);
        try {
            if (openDialog.type === "accept") {
                await approveDepositRequest(row._id, adminDiscount);
                toast.success("Deposit approved");
            } else {
                await rejectDepositRequest(row._id, reason.trim());
                toast.success("Deposit rejected");
            }

            onClose();
            onDone?.();
        } catch (e) {
            console.error(e);
            toast.error("Failed to process deposit request");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Dialog open={Boolean(openDialog?.open)} onClose={onClose} maxWidth="sm" fullWidth>
            <Box sx={{ p: 2.5 }}>
                <Typography variant="h6" gutterBottom>
                    {title}
                </Typography>

                {/* Basic info preview (customize as needed) */}
                <Box sx={{ mb: 2, p: 1.5, borderRadius: 2, bgcolor: "#fafafa" }}>
                    <Grid container spacing={1}>
                        <Grid item xs={12} md={6}>
                            <Typography variant="caption" color="text.secondary">
                                Ref ID
                            </Typography>
                            <Typography variant="body2">{row?.refId || "-"}</Typography>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Typography variant="caption" color="text.secondary">
                                Total
                            </Typography>
                            <Typography variant="body2">{currencyFormat(row?.deposit || "-")}</Typography>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Typography variant="caption" color="text.secondary">
                                User
                            </Typography>
                            <Typography variant="body2">{
                                row?.createdBy?.name ? `${row.createdBy.name} ${getFirstLetters(
                                    row.createdBy.placeId ? row.createdBy.placeId.name : row.createdBy.merchantId ? row.createdBy.merchantId.name : ''
                                ).toUpperCase() || 'STC'}` : row?.merchantId?.name ? `${row.merchantId.name}` : "-"}
                            </Typography>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Typography variant="caption" color="text.secondary">
                                Discount
                            </Typography>
                            <TCInput
                                value={adminDiscount}
                                disabled={openDialog?.type === "reject"}
                                onChange={(e) => {
                                    let value = e.currentTarget.value
                                    if (!value) {
                                        setAdminDiscount(value)
                                        return
                                    }
                                    if (isNaN(value * 1)) {
                                        value = adminDiscount
                                    } else {
                                        value = (value * 1)
                                        if (value > row?.deposit) {
                                            value = row?.deposit
                                        }
                                        if (value <= 0) {
                                            value = "0"
                                        }
                                    }
                                    setAdminDiscount(value)
                                }}
                            />
                        </Grid>
                    </Grid>
                </Box>

                {/* {isReject && (
                    <Box sx={{ mb: 2 }}>
                        <TCInput
                            fullWidth
                            label="Reject Reason*"
                            value={reason}
                            onChange={(e) => setReason(e.target.value)}
                            placeholder="Example: payment proof not valid"
                            multiline
                            minRows={3}
                        />
                        <Typography variant="caption" color="text.secondary">
                            Minimum 3 characters.
                        </Typography>
                    </Box>
                )} */}

                <Box display="flex" justifyContent="flex-end" gap={1}>
                    <Button variant="outlined" color="secondary" onClick={onClose} disabled={loading}>
                        Cancel
                    </Button>

                    <ButtonComponent
                        disabled={!isValid}
                        onClick={onSubmit}
                        loading={loading}
                        label={isReject ? "Reject" : "Approve"}
                        loadingLabel={isReject ? "Rejecting..." : "Approving..."}
                        buttonColor={isReject ? "error" : "primary"}
                        spinnerColor={isReject ? "error.main" : "primary.main"}
                        textColor="#fff"
                    />
                </Box>
            </Box>
        </Dialog>
    );
}
